import React from 'react';
import { useGame } from 'context/GameContext';
import Admin from 'admin';
import actions, { ActionTypes, departsFromTown } from 'model/actions';
import Button from './Button';
import Action from './actions/Action';

const Actions = ({ reset }) => {
  const { gameState } = useGame();
  const { party } = gameState;

  const entries = Object.keys(actions).map(key => {
    const action = actions[key];
    // Depart is a travelling verb out here and a door in a town, so it leaves this strip while
    // the party is standing in one — the town page carries it. See departsFromTown.
    const belongsHere = !(action.index === ActionTypes.Depart && departsFromTown(party));
    return {
      ...action,
      visible: belongsHere && action.isVisible(party.phase, action.index)
    };
  });

  return (
    <>
      {entries.map(
        action =>
          action.visible && (
            <Action
              key={action.index} // TODO: Change this action.type
              {...action}
            />
          )
      )}
      {Admin().canReset && <Button text="Reset" onClick={() => reset()} />}
    </>
  );
};

export default Actions;
